const { $ } = window;

window.YP.PlaceManager = function YPPlaceManager() {
    return {
        init: function init() {
            $('.js-place').each(function() {
                YP.PlaceManager().initPlaceLocator($(this).attr("data-ressource-id"));
            });
        },
        initPlaceLocator: function initPlaceLocator(identifier) {
            if (typeof identifier === 'undefined') {
                var searchLocation        = '.search_location';
                var placeDetails          = '.place-details';
                var placeSearchInput      = '.place-search-input';
                var placeLocationName     = '.place_location_name';
                var placeLocationAddr     = '.place_location_addr';
                var placeLocationCity     = '.place_location_city';
                var placeLocationCountry  = '.place_location_country';
                var placeLocationPostcode = '.place_location_postcode';
                var placeLocationLat      = '.place_location_lat';
                var placeLocationLng      = '.place_location_lng';
                var searchNoResult        = '.search-no-result';
                var placeBackToSearch     = '.place-backtosearch';
            }
            else {
                var searchLocation        = '.search_location_'+identifier;
                var placeDetails          = '.place-details_'+identifier;
                var placeSearchInput      = '.place-search-input_'+identifier;
                var placeLocationName     = '.place_location_name_'+identifier;
                var placeLocationAddr     = '.place_location_addr_'+identifier;
                var placeLocationCity     = '.place_location_city_'+identifier;
                var placeLocationCountry  = '.place_location_country_'+identifier;
                var placeLocationPostcode = '.place_location_postcode_'+identifier;
                var placeLocationLat      = '.place_location_lat_'+identifier;
                var placeLocationLng      = '.place_location_lng_'+identifier;
                var searchNoResult        = '.search-no-result_'+identifier;
                var placeBackToSearch     = '.place-backtosearch_'+identifier;
            }

            $(placeLocationAddr).prop('readonly', true);
            $(placeLocationCity).prop('readonly', true);
            $(placeLocationCountry).prop('readonly', true);
            $(placeLocationPostcode).prop('readonly', true);


            $(searchLocation).change(function() {
                if ($(searchLocation).is(':empty')) {
                    $(placeLocationAddr).val('');
                    $(placeLocationLat).val('');
                    $(placeLocationLng).val('');
                    $(placeLocationName).val('');
                    $(placeLocationCity).val('');
                    $(placeLocationCountry).val('');
                    $(placeLocationPostcode).val('');
                }
            });
            const sfInputName = $(searchLocation).prop('name');
            const sfInputId = $(searchLocation).prop('id');
            const sfInputClass = $(searchLocation).prop('class');
            const sfInputVal = $(searchLocation).prop('value');
            var parent = $(searchLocation).parent();
            $(searchLocation).remove();
            var geocoderInput = $(parent).geocomplete();
            geocoderInput.setValue(sfInputVal);
            geocoderInput.on('select', function onPlaceChanged(result) {
                $(placeDetails).show();
                $(placeSearchInput).hide();

                $(searchLocation).val(result.properties.formatted || '');
                $(placeLocationName).val(result.properties.name || '');
                $(placeLocationName).focus();

                // Fill the form
                $(placeLocationAddr).val(`${result.properties.housenumber || ''} ${result.properties.street || ''}`);
                $(placeLocationCity).val(`${result.properties.city || ''}`);
                $(placeLocationCountry).val(`${result.properties.country || ''}`);
                $(placeLocationPostcode).val(`${result.properties.postcode || ''}`);
                $(placeLocationLat).val(result.properties.lat);
                $(placeLocationLng).val(result.properties.lon);

                $(placeLocationAddr).prop('readonly', true);
                $(placeLocationCity).prop('readonly', true);
                $(placeLocationCountry).prop('readonly', true);
                $(placeLocationPostcode).prop('readonly', true);

                if ($('.js-event-form').length > 0) {
                    window.YP.EventManager().changeLodgingSuggestionInput();
                }
            });
            var newInput = $(parent).find('input');
            newInput.prop('name', sfInputName);
            newInput.prop('id', sfInputId);
            newInput.prop('autocomplete', 'no');
            newInput.addClass(sfInputClass);

            if ($(searchNoResult).length > 0) {
                $(searchNoResult).click((e) => {
                    $(placeSearchInput).hide();
                    $(placeDetails).show();

                    $(placeLocationAddr).prop('readonly', false);
                    $(placeLocationCity).prop('readonly', false);
                    $(placeLocationCountry).prop('readonly', false);
                    $(placeLocationPostcode).prop('readonly', false);

                    $(placeLocationName).focus();
                    $(placeDetails + ' .preview_place_nomap').show();
                    e.preventDefault();
                });
            }

            if ($(placeBackToSearch).length > 0) {
                $(placeBackToSearch).click((e) => {
                    $(placeSearchInput).show();
                    $(placeDetails).hide();
                    $(searchLocation).val('').focus();

                    $(placeLocationAddr).val('');
                    $(placeLocationLat).val('');
                    $(placeLocationLng).val('');
                    $(placeLocationName).val('');
                    $(placeLocationCity).val('');
                    $(placeLocationCountry).val('');
                    $(placeLocationPostcode).val('');
                    $(placeDetails + ' .preview_place_nomap').hide();
                    e.preventDefault();
                });
            }
        },
    };
};

function initPlaceFunction() {
    YP.PlaceManager().init();
}

if (document.readyState === 'complete') {
    initPlaceFunction();
} else {
    window.addEventListener("load", initPlaceFunction);
}
